import React from 'react';

//*Mui
import { Modal, Box } from '@mui/material';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../Redux Store/actions';

//*files
import Close from '../../Components/Icons/Close';
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect } from 'react';
import cssClasses from './ViewAllotmentSoldDetails.module.css';

function ViewAllotmentSoldDetails({ open, handleClose, data }) {
  const [AllotmentSoldData, setAllotmentSoldData] = useState([]);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);

  const style = {
    position: 'absolute',
    top: '50%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '91%',
    width: '60%',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
  };

  useEffect(() => {
    AllotmentDetails();
  }, []);

  function numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000).toFixed(2) + ' Cr';
    else if (val >= 100000) val = (val / 100000).toFixed(2) + ' Lac';
    else if (val >= 1000) val = (val / 1000).toFixed(2) + ' K';
    return val;
  }

  function AllotmentDetails() {
    // console.log('data', data);
    const modifiedData = data.map((elm, index) => ({
      ...elm,
      id: elm.allotmentPaymentId,
      LeadName: elm.leadId?.personId?.name,
      ProductType: elm.unitId?.inventoryTypeId?.type,
      Source: elm.leadId?.leadType,
      Area: elm.unitId?.chargeableArea,
      UnitNo: elm.unitId?.unitNo,
      Wing: elm.unitId?.wingId?.wingName,
      Value: numDifferentiation(elm.unitId?.totalCost),
      AllotedOn: elm.created_at,
      ProjectName:elm.unitId?.projectId?.projectName,
    }));

    // console.log('modifieddta', modifiedData);
    setAllotmentSoldData([...modifiedData]);
  }
  const dataGridStyles = {
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    border: '1px solid #EAECF0 !important',
    fontWeight: '400',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: '#667085',
    fontFamily: 'Inter-Medium',
    borderRadius: '8px',
    '& div[data-colindex="1"]': {
      color: '#101828',
      fontWeight: '500',
    },
    '& .MuiDataGrid-virtualScrollerRenderZone': {
      '& .MuiDataGrid-row': {
        borderBottom: '1px solid #EAECF0',
        background: '#FFFFFF',
        /* Shadow/xl */

        // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        borderRadius: '1rem',

        //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
        //   backgroundColor: "#FFFFFF",
      },
      '& .MuiDataGrid-row.Mui-selected:hover': {
        borderBottom: '1px solid #EAECF0',
        backgroundColor: '#FFFFFF',
        // "&:nth-of-type(2n+1)": {
        //   backgroundColor: "rgba(249, 250, 251, 1)",
        // },
      },
    },
    '& .MuiDataGrid-iconSeparator ': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeader:hover': {
      '& .MuiDataGrid-menuIcon': {
        visibility: 'hidden',
      },
    },

    '&  .MuiDataGrid-columnHeaders': {
      background: '#F9FAFB',
      /* Gray/200 */
      border: '1px solid #EAECF0',
      /* Shadow/xl */
      // boxShadow:
      //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      // borderRadius: "8px",

      marginBottom: '1rem',
      borderBottom: '6px solid #EAECF0',
    },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-checkboxInput': {
      '& svg': {
        width: '2rem',
        height: '2rem',
        background: '#FFFFFF',
      },
    },
    // "& .MuiTablePagination-displayedRows": {
    //   display: "none",
    // },
    '& .MuiDataGrid-footerContainer': {
      '& .MuiTablePagination-displayedRows ': {
        display: 'none',
      },
      '& .MuiDataGrid-selectedRowCount': {
        visibility: 'hidden ',
      },
    },
    "&  [title='Sort']": {
      //visibility:"hidden",
      display: 'none',
      cursor: 'none',
    },
    "& [title='Go to previous page']": {
      borderRadius: '0',
      border: '1px solid #EAECF0',
      borderRadius: '0.8rem',
      marginRight: '0.5rem',
    },
    "& [title='Go to next page']": {
      borderRadius: '0',
      border: '1px solid #EAECF0',
      borderRadius: '0.8rem',
      marginRight: '0.5rem',
    },
    "& [title='Go to previous page']:after": {
      content: "'Previous'",
      marginLeft: '1rem',
    },
    "& [title='Go to next page']:before": {
      content: "'Next'",
      marginRight: '1rem',
    },
    '& .MuiDataGrid-columnHeader': {
      padding: '0 4rem',

      '&:focus': {
        outline: 'none',
      },
    },
    '&  .MuiDataGrid-row ': {
      maxHeight: '72px !important',
      minHeight: '72px !important',
    },
    '& .MuiDataGrid-cell': {
      padding: '0 4rem',
      minHeight: '72px !important',
      maxHeight: '72px !important',
      '&:focus': {
        outline: 'none',
      },
    },
    '& .MuiButtonBase-root': {
      fontSize: '1.6rem',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
    },
    '& .MuiDataGrid-cell': {
      padding: '0 2rem',
      minHeight: '72px !important',
      maxHeight: '72px !important',
      '&:focus': {
        outline: 'none',
      },
    },
    '& .MuiDataGrid-columnHeader': {
      padding: '0 1rem',

      '&:focus': {
        outline: 'none',
      },
    },
  };

  const AllotmentSoldColumns = [
    {
      field: 'LeadName',
      headerName: 'Lead Name',
      width: 240,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle} whiteSpace={'break-spaces'}>
            {params?.row?.LeadName ?? ''}
          </Box>
        );
      },
    },
    // {
    //   field: 'ProjectName',
    //   headerName: 'Project Name',
    //   width: 250,
    //   renderCell: (params) => {
    //     return (
    //       <Box className={cssClasses.innerTitle}>
    //         {params?.row?.ProjectName ?? ''}
    //       </Box>
    //     );
    //   },
    // },
    {
      field: 'ProductType',
      headerName: 'Product Type',
      width: 150,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {params?.row?.ProductType ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Source',
      headerName: 'Source',
      width: 100,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {params?.row?.Source ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Area',
      headerName: 'Area',
      width: 120,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle1}>{`${params?.row?.Area} sq.ft` ?? ''}</Box>
        );
      },
    },
    {
      field: 'UnitNo',
      headerName: 'Unit No',
      width: 100,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {params?.row?.UnitNo ?? ''}
          </Box>
        );
      },
    },
    {
      field: 'Wing',
      headerName: 'Wing',
      width: 100,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>{params?.row?.Wing ?? ''}</Box>
        );
      },
    },
    {
      field: 'Value',
      headerName: 'Value',
      width: 100,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.innerTitle}>
            {`₹ ${params?.row?.Value}` ?? ''}
          </Box>
        );
      },
    },
    // {
    //   field: 'AllotedOn',
    //   headerName: 'Alloted On',
    //   width: 240,
    //   renderCell: (params) => {
    //     return (
    //       <Box className={cssClasses.innerTitle}>
    //         {new Date(params?.row?.AllotedOn).toDateString()},{' '}
    //         {new Date(params?.row?.AllotedOn).toLocaleTimeString([], {
    //           hour: '2-digit',
    //           minute: '2-digit',
    //         })}
    //       </Box>
    //     );
    //   },
    // },
  ];

  function getMoreData() {}

  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleClose();
          }
        }}
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.HeaderTitle} m={1}>
                  Sales Person - {data[0]?.leadId?.userId?.name}
                </Box>{' '}
              </Box>
              <Box
                ml={'auto'}
                mt={2}
                mr={1}
                onClick={handleClose}
                style={{ cursor: 'pointer' }}
              >
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box style={{ height: '88.7%', width: '96%' }}>
            <Box style={{ height: '100%', width: '100%' }}>
              <Box style={{ height: '100%', width: '100%', margin: '1rem 2rem' }}>
                <DataGrid
                  rows={AllotmentSoldData}
                  columns={AllotmentSoldColumns}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  page={pageMaintain}
                  onPageChange={(_page) => {
                    setPageMaintain(_page);
                    if (pageNumber < _page) {
                      getMoreData(_page);
                    }
                  }}
                  sx={[dataGridStyles]}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default ViewAllotmentSoldDetails;
